<template>
  <div>
    <TabbedPortletContainer>
      <TabbedPortlet>
        <TabbedPortletHead>
          <li class="nav-item">
            <a href=""
              class="nav-link"
              :class="{ 'active': selectedTab === tabs.MY_PROFILE }"
              @click.prevent="selectTab(tabs.MY_PROFILE)">My profile</a>
          </li>
          <li class="nav-item">
            <a href=""
              class="nav-link"
              :class="{ 'active': selectedTab === tabs.CHANGE_PASSWORD }"
              @click.prevent="selectTab(tabs.CHANGE_PASSWORD)">Change password</a>
          </li>
        </TabbedPortletHead>

        <TabbedPortletBody>
          <div class="tab-content">
            <TabbedPortletBodyTab :show="selectedTab === tabs.MY_PROFILE">
              <PersonalInformation />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.CHANGE_PASSWORD">
              <ChangePassword />
            </TabbedPortletBodyTab>
          </div>
        </TabbedPortletBody>

      </TabbedPortlet>
    </TabbedPortletContainer>
  </div>
</template>

<script>
import TabbedPortletContainer from '@/components/_shared/tabbed-portlet/TabbedPortletContainer.vue'
import TabbedPortlet from '@/components/_shared/tabbed-portlet/TabbedPortlet.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import PersonalInformation from '@/components/profile/PersonalInformation.vue'
import ChangePassword from '@/components/profile/ChangePassword.vue'

export default {
  name: 'ProfileWrapper',
  data () {
    const MY_PROFILE = 'my-profile'
    const CHANGE_PASSWORD = 'change-password'

    return {
      selectedTab: MY_PROFILE,
      tabs: {
        MY_PROFILE,
        CHANGE_PASSWORD
      }
    }
  },
  components: {
    TabbedPortletContainer,
    TabbedPortlet,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    PersonalInformation,
    ChangePassword
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-link:hover,
.nav-link.active,
a.nav-link:hover,
a.nav-link.active {
  color: #cc0000 !important;
  border-bottom: 1px solid #cc0000 !important;
}
</style>
